import React, { FC, useMemo } from "react";
import { useUser } from "src/hooks/useUser";

import { OwnerOptionsEntity, SchemaHeaderEntity } from "./SchemaHeader";
import SchemaIcon from "src/components/icons/SchemaIcon";
import SimpleDropdown from "src/components/SimpleDropdown";
import { AllOrgNamesQuery } from "src/lib/graphql/types";
import { useQuery } from "@apollo/client";
import { getAllOrgNames } from "src/lib/graphql/org.queries";

type CreateSchemaChildProps = {
  schema: SchemaHeaderEntity;
  ownerOptions: OwnerOptionsEntity;
};

const CreateSchemaChild: FC<CreateSchemaChildProps> = ({
  schema,
  ownerOptions,
}) => {
  const [user] = useUser();

  if (!user) {
    return null;
  }

  return (
    <div style={{ marginTop: 6 }} className="fork-subject-form">
      <SimpleDropdown
        label={
          <span style={{ display: "flex", alignItems: "center" }}>
            Create Child <SchemaIcon style={{ marginLeft: 5 }} />
          </span>
        }
        options={ownerOptions.map((option) => ({
          label: <span>{option.label}</span>,
          value: option.value,
          href: `/@${option.value}/schemas/create-new?subTypeName=${schema.name}&subTypeNamespace=${schema.namespace}`,
        }))}
        className="schema-simple-dropdown"
        style="white"
      />
    </div>
  );
};

export default CreateSchemaChild;
